<ng-select
  #orgSelect
  [fixNgSelectBottom]="orgSelect"
  data-cy="orgSelect"
  class="w-[180px] select-none text-base"
  (open)="openOrgSelect()"
  [loading]="orgsListLoading"
  [items]="orgsList"
  [clearable]="false"
  [searchable]="false"
  [(ngModel)]="selectedOrgId"
  (change)="orgChange()"
  (keyup.esc)="$event.stopImmediatePropagation(); orgSelect.blur()"
  (keyup.enter)="$event.stopImmediatePropagation(); orgSelect.blur()"
  [disabled]="needSave === true"
  appendTo="body"
  placeholder="Organization"
  bindLabel="name"
  bindValue="orgId"
>
  <ng-template ng-label-tmp let-item="item">
    <div class="ml-1 truncate">{{ item.name }}</div>
  </ng-template>

  <ng-template ng-option-tmp let-item="item">
    <div class="ml-1 truncate">{{ item.name }}</div>
  </ng-template>

  <ng-template ng-footer-tmp>
    <div
      tp="Demo user is restricted"
      placement="left"
      [tpIsEnabled]="alias === restrictedUserAlias"
    >
      <button
        data-cy="orgSelectCreateOrgButton"
        class="w-full rounded py-3 text-base focus:outline-none"
        [ngClass]="{
          'text-m600 hover:bg-m50': alias !== restrictedUserAlias,
          'text-s400 cursor-default': alias === restrictedUserAlias
        }"
        (click)="createNewOrg()"
        [disabled]="alias === restrictedUserAlias"
        >New Org</button
      >
    </div>
  </ng-template>
</ng-select>

<div *ngIf="selectedOrg$ | async"></div>
<div *ngIf="needSave$ | async"></div>
<div *ngIf="alias$ | async"></div>
